import React from "react";

import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import { Grid, IconButton } from "@mui/material";
import { isMobile } from "react-device-detect";

import useStyle from "./Suppot.style";

const DialogModal = ({
  handleClickOpen,
  handleClose,
  open,
  message,
  chatImage
}) => {
  const classes = useStyle();
  return (
    <>
      {message?.file_path && (
        <button
          className="chat-img"
          onClick={() => handleClickOpen(message?.file_path)}
        >
          <img src={message?.file_path} alt="" style={{ cursor: "pointer" }} />
        </button>
      )}
      <Dialog
        className={classes.dialogImageWrap}
        componentsProps={{
          backdrop: {
            style: { backgroundColor: "transparent" }
          }
        }}
        maxWidth={isMobile ? "90%" : ""}
        // maxHeight={isMobile ? "90%" : ""}
        // fullScreen={isMobile ? "90%" : ""}
        open={open}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
      >
        <IconButton
          edge="end"
          color="inherit"
          onClick={handleClose}
          aria-label="close"
          className="close-btn"
          sx={{
            position: "absolute",
            right: 18,
            top: 8
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent className={classes.dialogImage}>
          <Grid className="dialog-img-wrap">
            <img
              // height={500}
              // width={500}
              src={chatImage}
              alt=""
              style={{ cursor: "pointer" }}
            />
          </Grid>
          {/* </button> */}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DialogModal;
